import React from 'react';
import { connect } from 'react-redux';
// LevelEditor imports
import { itemSelectorToggle, toggleBackgroundMode } from '../../../../../actions/levelEditorActions';
import { setActiveSidebarItem } from '../../../../../actions/sideBarActions';
// Game(kit) imports
import gameKit from '../../../../../../GameKit';
// Shared imports
import { LevelEditorModeEnum, SideBarItems } from '../../../../../shared';
import settings from '../../../../../../settings';

class BtnCollapse extends React.Component {
    handleClick = () => {
        const { levelEditor, dispatch } = this.props;
        if (levelEditor.mode === LevelEditorModeEnum.BACKGROUND) {
            dispatch(toggleBackgroundMode());
            dispatch(setActiveSidebarItem(SideBarItems.NONE));
            gameKit.levelEditor.exitTileMode();
        }
        dispatch(itemSelectorToggle());
    };

    render = () => {
        const { levelEditor } = this.props;

        const activeClass = levelEditor.itemSelectorOpen ? 'active' : '';

        return (
            <button type="button" className={`btn-item-selector-close ${activeClass}`} onClick={this.handleClick}>
                <img src={`${settings.assetsPath}img/icons/bouwsteen-sluit.png`} alt="Sluit bouwstenen" title="Sluit bouwstenen" />
            </button>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BtnCollapse);
